/**
 * DEV-260 — listas "da base" (FR-015) via gateway público. Loading, vazio e
 * erro são três estados distintos; busca server-side debounced (regra
 * `server-side-search.md`): o `signal` do TanStack cancela a anterior.
 */
import { useQuery } from '@tanstack/react-query';
import { alignmentApi, type CatalogueName } from '../../shared/api';

export interface CatalogueState<T> {
  items: T[];
  loading: boolean;
  failed: boolean;
}

export function useCatalogue<T>(
  session: string,
  name: CatalogueName,
  params: Record<string, string | undefined> = {},
  enabled = true
): CatalogueState<T> {
  const query = useQuery({
    queryKey: ['alignment-catalogue', name, params],
    queryFn: ({ signal }) => alignmentApi.getCatalogue<T>(session, name, params, signal),
    enabled,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
  return {
    items: query.data?.items ?? [],
    loading: enabled && query.isPending,
    failed: query.isError,
  };
}

export interface StateItem {
  id: number;
  acronym: string;
  name: string;
}
export interface CityItem {
  id: number;
  name: string;
  stateAcronym?: string;
}
export interface NamedItem {
  id: number;
  name: string;
}
export interface LabeledItem {
  id: number;
  label: string;
}
